import React from "react";
import { Streamdown, defaultRemarkPlugins } from "streamdown";
import { EntityUriLink } from "@/components/entityReference/entityReferenceLink";

const ENTITY_REFERENCE_TAG = "entity-reference";

// Moves invono:// links into a custom element before sanitization, which would otherwise strip the unknown protocol.
const remarkEntityReferences = () => (tree) => {
  const visit = (node) => {
    if (node.type === "link" && node.url?.startsWith("invono://")) {
      node.data = {
        ...node.data,
        hName: ENTITY_REFERENCE_TAG,
        hProperties: { uri: node.url },
      };
    }
    node.children?.forEach(visit);
  };
  visit(tree);
};

const remarkPlugins = [
  ...Object.values(defaultRemarkPlugins),
  remarkEntityReferences,
];
const allowedTags = { [ENTITY_REFERENCE_TAG]: ["uri"] };
const components = { [ENTITY_REFERENCE_TAG]: EntityUriLink };

export const MessageResponse = ({ className, ...props }) => (
  <Streamdown
    className={className}
    remarkPlugins={remarkPlugins}
    allowedTags={allowedTags}
    components={components}
    {...props}
  />
);
